import { dateToISO8601 } from './dateToISO8601';

import { IParamsReq } from 'types';

export const getISO8601DateRangeValue = (search: IParamsReq) => {
  const copiedSearch = Object.assign({}, search);

  if ('start' in copiedSearch) {
    copiedSearch.start = dateToISO8601(String(copiedSearch.start));
  }

  if ('end' in copiedSearch) {
    copiedSearch.end = dateToISO8601(String(copiedSearch.end));
  }

  return copiedSearch;
};
